export const isTest = import.meta.env?.MODE === 'test'
export default isTest
